var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('index-view',{attrs:{"view-name":"expenses","module":_vm.module,"model":_vm.model,"list":_vm.list,"pagination":_vm.pagination,"sort":_vm.sort,"summary":_vm.summary,"view-config":_vm.viewConfig,"fetch":_vm.fetch}})}
var staticRenderFns = []

export { render, staticRenderFns }